<template>
	<div class="appWhite rounded-lg pa-4" style="max-width: 512px">

		<!--Icon | Title-->
		<div class="d-flex align-center">
			<app-icon class="flash mr-4" color="orange" icon="error" size="32"/>
			<app-text color="primary" size="normal-bold">Complete Your Profile</app-text>
		</div>

		<!--Message-->
		<app-text class="mt-4">Please complete your profile before continuing</app-text>

		<!--Action Button-->
		<div class="d-flex justify-end mt-4">
			<app-btn @click.native="MIX_go('/myProfile')" label="Continue"/>
		</div>

	</div>
</template>

<script>

export default {

	name: "HomeUpdateProfile",

	data: () => ({}),

	methods: {},

}
</script>

<style scoped>

</style>
